<template>
  <v-container class="px-0 pt-0">
    <v-row>
      <!-- TODO: come up with a 404 page -->
      <!-- TODO: refactor to get rid of unnecessary v-cols and v-rows -->
      <v-carousel :height="carouselHeight" hide-delimiter-background :cycle="false" interval="5000">
        <v-carousel-item eager v-for="testimonial in testimonialArray" :key="testimonial.name">
          <v-col cols="12" class="d-flex justify-center align-center py-0">
            <v-card
              class="d-flex flex-column justify-center align-center
            pt-2 pb-12
            secondary"
            :height="carouselHeight"
            width="100%"
            >
              <span class="text-h4">Testimonials</span>
              <!-- Layout for phones -->
              <v-row v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.xs"
              class="d-flex justify-center">
                <v-col class="d-flex  flex-column py-0 mt-1" cols="10">
                  <v-card class="d-flex white elevation-10 flex-column py-0 mt-1">
                    <v-row class="justify-center align-center mt-1">
                      <v-avatar size="150">
                        <v-img
                          :src="require(`@/assets/img/testimonials/${testimonial.folder}/1x.jpg`)"
                      :lazy-src="require(`@/assets/img/testimonials/${testimonial.folder}/1x.jpg`)"
                          :srcset="`
                          ${require(`@/assets/img/testimonials/${testimonial.folder}/1x.jpg`)} 200w,
                          ${require(`@/assets/img/testimonials/${testimonial.folder}/2x.jpg`)} 400w
                          `"
                          />
                      </v-avatar>
                    </v-row>
                    <v-row class="d-flex pt-0 justify-center blockquote">
                      <v-card-text class="font-italic info--text pt-0">
                        {{ testimonial.quote }}
                      </v-card-text>
                      <v-card-subtitle class="font-italic pt-0 info--text">
                        -{{ testimonial.name }}
                      </v-card-subtitle>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
              <!-- Layout for everything bigger than a phone -->
              <v-row v-else class="d-flex justify-center no-gutters">
                <v-col class="d-flex white elevation-10" cols="10">
                  <!-- <v-row class="d-flex flex-row-reverse justify-center no-gutters"> -->
                    <!-- <v-col class="d-flex align-self-center justify-end"> -->
                      <v-avatar size="150" class="align-self-center ma-2">
                        <v-img
                        :src="require(`@/assets/img/testimonials/${testimonial.folder}/1x.jpg`)"
                      :lazy-src="require(`@/assets/img/testimonials/${testimonial.folder}/1x.jpg`)"
                          :srcset="`
                          ${require(`@/assets/img/testimonials/${testimonial.folder}/1x.jpg`)} 200w,
                          ${require(`@/assets/img/testimonials/${testimonial.folder}/2x.jpg`)} 400w
                          `"
                        />
                      </v-avatar>
                    <!-- </v-col> -->
                    <!-- <v-row class="d-flex flex-column justify-center blockquote"> -->
                    <!-- <v-col> -->
                      <div class="align-self-center">
                        <v-card-text class="font-italic info--text">
                          {{ testimonial.quote }}
                        </v-card-text>
                        <v-card-subtitle class="font-italic pt-0 info--text">
                          -{{ testimonial.name }}
                        </v-card-subtitle>
                      </div>
                    <!-- </v-col> -->

                  <!-- </v-row> -->
                  <!-- </v-row> -->
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-carousel-item>
      </v-carousel>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Testimonials',
  data() {
    return {
      debug: false,
      testimonialArray: [
        {
          name: 'John Schneider',
          folder: 'jSchneider',
          quote: `"AT LAST — Interchangeable fingerboards on great sounding guitars with any 
          historic tuning, or any you can imagine. Thank you Microtone Guitars, problem solved!"`,
        },
        {
          name: 'Jason Lewis',
          folder: 'jLewis',
          quote: ` “I’m mesmerized by the purity of chords on my MicroTone fretboards, 
          and can begin to understand the emotional diversity and character of different keys. 
          I can no longer bear the monotony of equal temperament!”`,
        },
        {
          name: 'Dan Lippel',
          folder: 'dLippel',
          quote: `"The flexibility of alternate fretting systems opens up a whole world of 
          musical possibilities, from playing early music in period temperaments to 
          experimenting with contemporary microtonal systems through existing repertoire 
          and commissions."`,
        },
      ],
    };
  },
  computed: {
    // bracketHeight() {
    //   // if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) {
    //   //   return '510';
    //   // }
    //   // return '680';
    //   // return 'auto';
    //   switch (this.$vuetify.breakpoint.name) {
    //     case 'xs':
    //       return '500';
    //     case 'sm':
    //       return '650';
    //     default:
    //       return 'auto';
    //   }
    // },
    carouselHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '500';
        case 'sm':
          return '300';
        case 'md':
          return '260';
        case 'lg':
          return '270';
        default:
          return 'auto';
      }
    },
  },
};
</script>

<style scoped></style>
